module.exports = __webpack_public_path__ + "static/oblakoder-home-2-aefcf1b116044dcf7ceddc89411074d2.png";